import { createContext } from "react";

const colorContext = createContext();

export default colorContext;